var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end"},[(_vm.selectedRows.length > 0)?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"danger","size":"sm"},on:{"click":_vm.onDelete}},[_vm._v(" Delete ")]):_vm._e(),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.onSSOINewReport}},[_vm._v(" New SSOI Report ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }